// Shared helpers and constants for AdminPanel tab modules.
import { Card } from "@/components/ui/card";

export const SCOPE_LABELS = {
  basic_1: "Klasa 1 — podstawowy",
  basic_2: "Klasa 2 — podstawowy",
  basic_3: "Klasa 3 — podstawowy",
  extended_1: "Klasa 1 — rozszerzony",
  extended_2: "Klasa 2 — rozszerzony",
  extended_3: "Klasa 3 — rozszerzony",
  extended_4: "Klasa 4 — rozszerzony",
};

// Color palette for the sidebar health dots — green/yellow/red.
export const DOT_COLOR = { green: "#22C55E", yellow: "#EAB308", red: "#EF4444" };

export function Section({ icon: Icon, title, children }) {
  return (
    <Card className="brut border-2 border-[#0F172A] rounded-md p-6 bg-white">
      <div className="flex items-center gap-3 mb-4">
        <Icon className="w-6 h-6" strokeWidth={2.5} />
        <h2 className="text-2xl font-black tracking-tight">{title}</h2>
      </div>
      {children}
    </Card>
  );
}

export function KpiTile({ label, value, sub, testId, accent = "#FEF08A" }) {
  return (
    <div
      className="brut border-2 border-[#0F172A] rounded-md p-4 bg-white shadow-[3px_3px_0_#0F172A]"
      data-testid={testId}
    >
      <div className="text-xs font-black uppercase tracking-wider text-[#64748B]">
        {label}
      </div>
      <div
        className="font-display font-black text-4xl mt-1 inline-block px-2 py-0.5 rounded"
        style={{ background: accent }}
      >
        {value}
      </div>
      {sub && <div className="text-xs text-[#64748B] mt-2">{sub}</div>}
    </div>
  );
}
